import { toast } from 'react-toastify';

import { AppDispatch } from '..';
import { fetchSystemProfile, updateSystemProfile } from '../../api';
import { SystemProfile } from '../../types/entities';
import { Logger } from '../../utils/Logger';

import { success, fail, loading, update, pending } from './reducer';

export const getSystemProfileAsync = () => {
  return (dispatch: AppDispatch) => {
    dispatch(loading(true));
    fetchSystemProfile()
      .then((response) => {
        const profile = response.data;
        Logger.log(profile);
        dispatch(success(profile));
      })
      .catch((error) => {
        const msg = error.response?.data.message || error.message;
        dispatch(fail(msg));
        toast.error(msg);
      });
  };
};

export const updateSystemProfileAsync = (profile: SystemProfile) => {
  return (dispatch: AppDispatch) => {
    dispatch(pending(true));
    updateSystemProfile(profile)
      .then(() => {
        Logger.log(profile);
        dispatch(update(profile));
      })
      .catch((error) => {
        const msg = error.response?.data.message || error.message;
        dispatch(fail(msg));
        toast.error(msg);
      });
  };
};
